import { render, staticRenderFns } from "./BolsaAppHeader.vue?vue&type=template&id=f48825a2&scoped=true"
import script from "./BolsaAppHeader.vue?vue&type=script&lang=js"
export * from "./BolsaAppHeader.vue?vue&type=script&lang=js"
import style0 from "./BolsaAppHeader.vue?vue&type=style&index=0&id=f48825a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48825a2",
  null
  
)

export default component.exports